import { useEffect, useState } from 'react';

function getMap(hash: string) {
  const map = new Map<string, string>();

  if (hash.length === 0) return map;

  hash
    .replaceAll(/#|\?/g, '')
    .split('&')
    .forEach((hashItem) => {
      const part = hashItem.split('=');

      if (part[0].length) {
        map.set(part[0], part.length > 1 ? part[1] : 'true');
      }
    });

  return map;
}

export const useHash = () => {
  const [hash, setHash] = useState(getMap(''));

  useEffect(() => {
    const onHashChange = () => {
      setHash(getMap(window.location.hash));
    };
    setHash(getMap(window.location.hash));
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return hash;
};
